import React from 'react';

import { useIntl } from 'react-intl';

import {
    CSSEditor,
    CSSEditorComponentWrapper,
    CSSEditorWidgetProperties,
} from 'components/Editors/components/Editor.style';

import { JRCButton } from 'components/JRCButton/JRCButton';

import { JRCWidgetImageProps } from './JRCWidgetImage';
import { EditorInput } from 'components/Editors/components/EditorInput';

/**
 * This is the default image editor
 */
export const JRCWidgetImageEditor = ({
    uri,
    maxWidth,
    onChange,
}: JRCWidgetImageProps & {
    onChange: (content: Partial<JRCWidgetImageProps>, override?: boolean) => void;
}) => {
    const intl = useIntl();

    return (
        <CSSEditor>
            <CSSEditorWidgetProperties>
                <CSSEditorComponentWrapper>
                    <EditorInput
                        label={intl.formatMessage({ id: 'EDITOR_Image_Url' })}
                        initialValue={uri}
                        onChange={(uri) => onChange({ uri })}
                    />
                </CSSEditorComponentWrapper>
                <CSSEditorComponentWrapper>
                    <EditorInput
                        label={intl.formatMessage({ id: 'EDITOR_Image_Max_Width' })}
                        initialValue={String(maxWidth)}
                        onChange={(maxWidth) => onChange({ maxWidth: parseInt(maxWidth) })}
                    />
                </CSSEditorComponentWrapper>
            </CSSEditorWidgetProperties>
            <JRCButton onClick={() => onChange({ uri })} variant={'outlined'} minWidth={'100%'}>
                {intl.formatMessage({ id: 'PANEL_Save_And_Close' })}
            </JRCButton>
        </CSSEditor>
    );
};
